import { BuiltinCall } from '../BuiltinCall';
class DeclareEvent extends BuiltinCall {
    emitCall(sb, node, options) {
        if (!options.pushValue) {
            return;
        }
        sb.emitHelper(node, options, sb.helpers.wrapUndefined);
    }
}
export const add = (builtins) => {
    builtins.addContractValue('declareEvent', new DeclareEvent());
};

//# sourceMappingURL=declareEvent.js.map
